import { api } from '../core';
import { PageUpdate } from './types';

export interface MarkBlankRequest {
  pageIds: string[];
}

// Response is directly an array of PageUpdate objects
export type MarkBlankResponse = PageUpdate[];

export interface MarkBlankProps {
  abortController?: AbortController;
  pageIds: string[];
  documentId?: string;
}

const markBlankApi = api.injectEndpoints({
  endpoints: (builder) => ({
    markBlank: builder.mutation<MarkBlankResponse, MarkBlankProps>({
      query: ({ abortController = new AbortController(), pageIds }: MarkBlankProps) => ({
        url: 'gdpr/mark/blank',
        method: 'POST',
        signal: abortController.signal,
        body: {
          pageIds
        }
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const { useMarkBlankMutation } = markBlankApi;
